import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const DepartmentPage = () => {
    const [departments, setDepartments] = useState([]);
    const [newDepartment, setNewDepartment] = useState("");
    const [editingDepartment, setEditingDepartment] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchDepartments();
    }, []);

    const fetchDepartments = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/departments/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
            });
            setDepartments(response.data);
        } catch (error) {
            console.error("Error fetching departments:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                name: newDepartment,
            };

            if (editingDepartment) {
                await axios.put(
                    `${API_BASE_URL}/departments/update/${editingDepartment.id}/`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
            } else {
                await axios.post(
                    `${API_BASE_URL}/departments/create/`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
            }
            fetchDepartments();
            closeModal();
        } catch (error) {
            console.error("Error saving department:", error);
            if (error.response && error.response.data) {
                alert(JSON.stringify(error.response.data));
            }
        }
    };

    const deleteDepartment = async (id) => {
        if (window.confirm("Are you sure you want to delete this department?")) {
            try {
                await axios.delete(`${API_BASE_URL}/departments/delete/${id}/`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                });
                fetchDepartments();
            } catch (error) {
                console.error("Error deleting department:", error);
            }
        }
    };

    const openModal = (department = null) => {
        if (department) {
            setEditingDepartment(department);
            setNewDepartment(department.name);
        } else {
            setEditingDepartment(null);
            setNewDepartment("");
        }
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingDepartment(null);
        setNewDepartment("");
    };

    return (
        <div style={{ display: "flex" }}>
            <CustomNavbar />
            <div className="container-fluid mt-5" style={{ width: "100%", padding: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h3 className="mb-4 text-center">Department Management</h3>

                    {/* Add New Department Button */}
                    <button className="btn btn-primary mb-4" onClick={() => openModal()}>
                        Add New Department
                    </button>

                </div>

                {/* Department List */}
                <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {departments.map((department) => (
                            <tr key={department.id}>
                                <td>{department.id}</td>
                                <td>{department.name}</td>
                                <td>
                                    <button
                                        className="btn btn-warning me-2"
                                        onClick={() => openModal(department)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => deleteDepartment(department.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Modal for Create/Update */}
                {showModal && (
                    <div
                        className="modal show d-block fade"
                        tabIndex="-1"
                        role="dialog"
                        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header bg-primary text-white">
                                    <h5 className="modal-title text-white">
                                        {editingDepartment
                                            ? "Update Department"
                                            : "Create New Department"}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        onClick={closeModal}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-4">
                                            <label className="form-label fw-bold">
                                                Department Name
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={newDepartment}
                                                onChange={(e) => setNewDepartment(e.target.value)}
                                                className="form-control"
                                                placeholder="Enter Department Name"
                                                required
                                            />
                                        </div>

                                        <div className="text-end">
                                            <button
                                                type="button"
                                                className="btn btn-secondary me-2"
                                                onClick={closeModal}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-primary">
                                                Save
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DepartmentPage;
